import api from '..'

export interface ExecuteCampaignsPayload {
  campaign_ids: number[]
}

export async function executeCampaigns(campaignIds: number[]): Promise<void> {
  await api.post('/campaigns/bulk/execute', {
    campaign_ids: campaignIds,
  } satisfies ExecuteCampaignsPayload)
}
